type AuthorizedUser = {
  email?: string;
  impersonatorEmail?: string;
  impersonatorUserToken?: string;
  isInitialMultiFactorAuthenticationRequired?: boolean;
  isLoggedIn: boolean;
  isUserBlocked?: boolean;
  roles?: Array<string>;
  userToken?: string;
};

export function isAuthorized<User>(options: { mapUser: (user: User) => AuthorizedUser }): (user: User) => boolean;
export function isAuthorized<User extends AuthorizedUser = AuthorizedUser>(): (user: User) => boolean;
export function isAuthorized<User>(options?: { mapUser?: (user: User) => AuthorizedUser }) {
  const { mapUser } = options ?? {};

  return (user: User) => {
    const {
      email,
      impersonatorEmail,
      impersonatorUserToken,
      isInitialMultiFactorAuthenticationRequired,
      isLoggedIn,
      isUserBlocked,
      userToken,
    } = mapUser ? mapUser(user) : (user as unknown as AuthorizedUser);

    const isImpersonating = impersonatorEmail && impersonatorUserToken;

    if (!isLoggedIn) {
      return false;
    }

    if (isImpersonating) {
      return true;
    } else if (isUserBlocked) {
      return false;
    } else if (!email && !userToken) {
      return false;
    } else if (isInitialMultiFactorAuthenticationRequired) {
      return false;
    } else {
      return true;
    }
  };
}
